import { START_BUILD_LIST, BUILD_LIST } from '../actions/ListActions';

const INITIAL_STATE = {
  building: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case START_BUILD_LIST:
      return {
        ...state,
        building: {
          ...state.building,
          [action.listKey]: true,
        },
      };

    case BUILD_LIST:
      return {
        ...state,
        building: {
          ...state.building,
          [action.meta.listKey]: false,
        },
      };

    default:
      return state;
  }
}
